// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34BeW","fullView":"styles_fullView__1UZ6W"};